import type { ApiResponse, Pagination } from "@/types";

import { BaseApi } from "../base.api";
import type {
  CreateQuizData,
  CreateQuizQuestionData,
  Quiz,
  QuizQuestion,
  UpdateQuizData,
  UpdateQuizQuestionData,
} from "./types";

export * from "./types";

/** Test va savollar API — backend'dagi quiz kontrollerlarining ko'zgusi. */
export class QuizzesApi extends BaseApi {
  private readonly quizUrl = "/quizzes";
  private readonly questionUrl = "/quiz-questions";

  /** Dars uchun test yoki `null`. */
  getByLesson(lessonId: number) {
    return this.request.get<Quiz | null, ApiResponse<Quiz | null>>(
      `${this.quizUrl}/lesson/${lessonId}`,
    );
  }

  createQuiz(data: CreateQuizData) {
    return this.request.post<Quiz, ApiResponse<Quiz>>(this.quizUrl, data);
  }

  updateQuiz(id: number, data: UpdateQuizData) {
    return this.request.patch<Quiz, ApiResponse<Quiz>>(`${this.quizUrl}/${id}`, data);
  }

  removeQuiz(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.quizUrl}/${id}`);
  }

  getQuestions(quizId: number) {
    return this.request.get<QuizQuestion[], Pagination<QuizQuestion>>(
      `${this.questionUrl}/quiz/${quizId}`,
      { params: { page: 1, limit: 100 } },
    );
  }

  createQuestion(data: CreateQuizQuestionData) {
    return this.request.post<QuizQuestion, ApiResponse<QuizQuestion>>(this.questionUrl, data);
  }

  updateQuestion(id: number, data: UpdateQuizQuestionData) {
    return this.request.patch<QuizQuestion, ApiResponse<QuizQuestion>>(
      `${this.questionUrl}/${id}`,
      data,
    );
  }

  removeQuestion(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.questionUrl}/${id}`);
  }

  /** Savollar tartibi — TO'LIQ ro'yxat bilan. */
  reorderQuestions(quizId: number, questionIds: number[]) {
    return this.request.post<QuizQuestion[], ApiResponse<QuizQuestion[]>>(
      `${this.questionUrl}/quiz/${quizId}/reorder`,
      { questionIds },
    );
  }
}

export const quizzesApi = new QuizzesApi();
